query UserCharts {
  userCharts(orderBy: CHART_POSITION_ASC) {
    nodes {
      id
      chartCaption
      chartPosition
      isActive
    }
  }
}